import React, {useEffect, useState} from 'react';
import {Container, Grid, ButtonBase, CircularProgress, ListItem, ListItemIcon, ListItemText, Button} from '@material-ui/core/';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import { useHistory } from "react-router-dom";
import {Close, Email, Filter1, VpnKey, CheckCircleOutline } from '@material-ui/icons';
import {TextField} from '@material-ui/core/';
import Form from 'components/Form/FormTwoColumns';
import DatosCiudadano from '../../AutorizarSolicitudesEmpadronamiento/DatosCiudadanoRENAP/DatosCiudadano'
import BotonPersonalizado from 'components/BotonNormal'
import {functions} from 'constants/index';
import ApiServices from 'services/ApiServices';
import {showMessageSuccessSimple, showMessageErrorSimple, showMessageError} from 'services/SweetAlert'
import MensajeAlerta from 'components/ResponseElement'
import LoadingSpinner from "components/LoadingSpinner";

function DatosCiudadanoRENAPRechazarSolicitud(props) {
    const classes = useStyles(),        
        [loading, setLoading] = React.useState(false),
        [open, setOpen] = useState(false),
        [mensaje, setMensaje] = useState({tipoError:'', tipoMensaje:''});        

    const CatalogoRechazoCiudadano =async ()=>{
            let newElements= Object. assign({}, elements); 
            if(props.catalogosDeRechazoDeSolicitud.ciudadano.length > 0){
                newElements.ciudadano.list= props.catalogosDeRechazoDeSolicitud.ciudadano;
                setElements(newElements);
                return;
            }
            
            try{            
                newElements.ciudadano.list=[];
                let responseCiudadano = await ApiServices.CatalogoDeRechazoEmpadronamientoCiudadano.listRegisterCriteria();
                
                if(responseCiudadano.error){
                }else {
                    props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DE_RECHAZO_DE_CIUDADANO(responseCiudadano.data)
                    newElements.ciudadano.list= responseCiudadano.data;
                } 
            }catch(exception){
                newElements.ciudadano.list=[];
            }
            setElements(newElements);
        };     
    
    const CatalogoRechazoInterno =async ()=>{
            let newElements= Object. assign({}, elements); 
            if(props.catalogosDeRechazoDeSolicitud.interno.length > 0){
                newElements.interno.list= props.catalogosDeRechazoDeSolicitud.interno;
                setElements(newElements);
                return;
            }        
            try{
                newElements.interno.list=[];
                let responseInterno = await ApiServices.CatalogoDeRechazoEmpadronamientoInterno.listRegisterCriteria();
                if(responseInterno.error){
                }else {
                    props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DE_RECHAZO_DE_INTERNO(responseInterno.data)
                    newElements.interno.list= responseInterno.data;
                } 
            }catch(exception){
                newElements.interno.list=[];
            }
            setElements(newElements);
        };        
    const RechazarSolicitudDeEmpadronamiento= async ()=>{        
        setLoading(true)
        try{
            var datos = {idSolicitud: props.datosSolicitudRenap, idRechazoCiudadano: elements.ciudadano.value, idRechazoInterno: elements.interno.value, observaciones: elements.observacion.value, password: elements.contraseña.value}
            const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.rechazar(datos)
            if(response.error!==null){
                setMensaje({tipoError:'error', tipoMensaje:'¡Oops! ' + response.error.message})                    
                setOpen(true)                                                      
                setLoading(false)
            }else{
                props.SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO(true)
                showMessageSuccessSimple('¡BIEN!','Solicitud de Empadronamiento rechazada con éxito. Solicitud # '+props.datosSolicitudRenap)
                beforeStep()
                setLoading(false)
                props.cerrarDialogo()
                props.actualizarTabla()
                props.ObtenerTotalDeSolicitudesPendientesDeRealizar()
            }   
        }catch(exception){
            setLoading(false)
            if (exception.status===404) {
                setMensaje({tipoError:'error', tipoMensaje:'¡Oops!' + "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste."})                    
                setOpen(true)                                      
            }
            else {
                setMensaje({tipoError:'error', tipoMensaje:'¡Oops!' + "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste."})                    
                setOpen(true)                                      
            }
        }                 
    };
        
    const Cancelar=()=>{
        props.SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO(false)
        props.cerrarDialogo()
        beforeStep()
    };    

    const handClose = (event, reason) =>{
        if (reason === 'clickaway') {return ;}
        setOpen(false)
    }    
    const beforeStep=()=>{
        props.SOLICITUD_EMPADRONAMIENTO_SET_STEP(props.step-4);    
    };

    const [elements,setElements] = useState({
        ciudadano: {  idelement: "ciudadano",  value:'', label: "Catálogo Rechazo Ciudadano *", pattern:"^[1-9][0-9]*$", validators: ['required'], errorMessages:['Dato requerido'], isError:false, elementType:'autocomplete', list: []},
        interno: {  idelement: "interno",  value:'', label: "Catálogo Rechazo Interno *", pattern:"^[1-9][0-9]*$", validators: ['required'], errorMessages:['Dato requerido'], isError:false, elementType:'autocomplete', list: []},
        observacion: { idelement: "observacion",  value:'', label: "Observación", pattern:"^[\\w1-9 _Ññ.,!¡\"#$%&/()=¿?'@*-]{0,1024}$", validators: ['required'], errorMessages:['Sin espacios al inicio y final'], isError:false, elementType:'input' },
        contraseña: {  idelement: "contraseña",  value:'', label: "Contraseña *", pattern:"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!¡:.;{}+=^~|%*¿?&/-])[A-Za-z\\d$@#$!¡:.;{}+=^~|%*¿?&/-]\\S{6,50}$", validators: ['required'], errorMessages:['Contraseña requerida'], isError:false, elementType:'password', finalRequiredLength: 50, },
    });    
    
    const [buttonList,setButtonList]= React.useState({
        "next":{"label":"Rechazar Solicitud","icon": <CheckCircleOutline />,"callback":RechazarSolicitudDeEmpadronamiento,"loading":false, "size":"medium", "background":"linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)", "border":"0px", "borderRadius":"3", "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",},   
    });

    useEffect(() => {
        if(props.rechazarSolicitud){
            (async () => {
                // console.log('render ', props.catalogosDeRechazoDeSolicitud)
                await CatalogoRechazoCiudadano();
                await CatalogoRechazoInterno();
            })();        
        }
    },[props.rechazarSolicitud])

    return (
        <div id="scroller" className={classes.root}>
            <div className={classes.colorComponente}>
                <Grid >
                    <Grid className={classes.marginText} item xs={12} > 
                        <DatosCiudadano open={props.open}/>
                    </Grid>
                </Grid><br/>
                <div className={classes.lineaDegradadaBottom}></div>
            </div> <br/>              

            <div maxWidth="md" className={classes.colorComponente}>
                <Grid container >
                    <MensajeAlerta type={mensaje.tipoError} content={mensaje.tipoMensaje} timeMessage={4000} open={open} handClose={handClose} />
                    <Grid className={classes.AlignTable} item xs={12} > <br/>                        
                        <ButtonBase className={classes.image}>
                            <img className={classes.img} alt="complex" src={"/assets/cambiarContraseña.png"} />
                        </ButtonBase>      
                        <h4 className={classes.h1} variant="h5" color="initial"><strong>Complete el formulario para rechazar la solicitud de RENAP.</strong></h4>
                    </Grid>                                       
                    <Grid className={classes.AlignTable} item xs={12} container direction="row" justify="center" alignItems="center"> <br/>
                        <Form   elements= {elements}  buttonList={buttonList} BotonCerrar={Cancelar} 
                                BotonRegresar={beforeStep} disabled={props.estaEmpadronado}
                        />
                    </Grid>           
                    <Grid className={classes.AlignTable} item xs={12} container direction="row" justify="center" alignItems="center"> <br/>
                        <div>Datos requeridos *</div>
                    </Grid>           
                </Grid><br/>
                <LoadingSpinner open={loading} message='Rechazando solicitud de RENAP'></LoadingSpinner>
                <div className={classes.lineaDegradadaBottom}></div>
            </div><br/>
        </div>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(DatosCiudadanoRENAPRechazarSolicitud);